module.exports = __webpack_public_path__ + "static/media/Caixa8.69c84feb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelCaixa/Caixa8.png
// module id = 2038
// module chunks = 0